import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeoService } from 'src/app/services/geo.service';
import { ProductService } from 'src/app/services/products.service';
import { VendorService } from 'src/app/services/vendor.service';
import Swal from 'sweetalert2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { from, lastValueFrom } from 'rxjs';
import { AppCoreService } from 'src/app/services/app-core.service';
import { Utilities } from 'src/app/models/utilities';

@Component({
    selector: 'app-chargedetails',
    templateUrl: './chargedetails.component.html',
    styleUrls: ['./chargedetails.component.scss']
})
export class ChargedetailsComponent {
    @Input() chargeDetailData: any;
    Id: number;
    countryList: [];
    countryCode: any;

    chargeDetailsForm: FormGroup;
    isFormSubmitted = false;
    isDetailFormSubmitted = false;
    chargesOptions: any[] = [];
    customerOptions: any[] = [];
    vendorOptions: any[] = [];
    productOptions: any[] = [];
    serviceOptions: any[] = [];
    destinationcountryList: any[] = [];
    destinationStateList: any[] = [];
    destinationCityList: any[] = [];

    //origincountryList: any[] = [];
    //originstateList: any[] = [];
    //origincityList: any[] = [];
    currentDate: any;
    mappingId: number;
    //chargeType: string;
    isMappingEdit = false;
    //isDetailEdit = false;

    //private gridApi!: GridApi;
    //private gridColumnApi!: ColumnApi;
    public context: any;

    // defaultColDef = {
    //     sortable: true,
    //     resizable: false,
    //     filter: true
    // };

    // gridOptions: GridOptions = {
    //     pagination: true,
    //     paginationPageSize: 10,
    //     domLayout: 'autoHeight'
    // }

    mappingDetailsRowData = [];

    mappingRowData = [];
    useEnterKey: any;
    // onGridReady(params: GridReadyEvent) {
    //     this.gridApi = params.api;
    //     this.gridColumnApi = params.columnApi;
    //     params.api.sizeColumnsToFit();
    // }
    chargeTypeFuelSurecharge: boolean = false;
    constructor(
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private geoService: GeoService,
        private ngxLoaderService: NgxUiLoaderService,
        private chargesService: ChargesService,
        private customerService: CustomerService,
        private vendorService: VendorService,
        private productService: ProductService,
        public activeModal: NgbActiveModal,
        private appCoreService: AppCoreService,
        private utilities: Utilities,
    ) { this.context = { componentParent: this }; }

    async ngOnInit() {
        // console.log('init : chargeDetailData', this.chargeDetailData);

        // const userData = this.appCoreService.GetUserData();
        // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        this.currentDate = this.formateDate().dateString;
        this.chargeDetailsForm = this.formBuilder.group({
            //ddlChargeType: [null, Validators.compose([Validators.required])],
            // txtFromDate: [this.currentDate, Validators.compose([Validators.required])],
            // txtToDate: [this.currentDate, Validators.compose([Validators.required])],
            ddlCharge: [this.chargesOptions[0], Validators.compose([Validators.required])],
            ddlProduct: [],
            ddlVendor: [],
            ddlService: [],
            ddlDestinationCountry: [null],
            ddlDestinationState: [null],
            ddlDestinationCity: [null],
            txtCalculationBy: ['Percentage'],
            txtMinimumAmount: [null, Validators.pattern(/^\d{0,10}(?:\.\d{0,3})?$/)],
            txtChargeableAmount: [null, Validators.compose([Validators.required, Validators.pattern(/^\d{0,10}(?:\.\d{0,3})?$/)])]
        });

        await this.bindCharges();
        await this.bindCustomer();
        await this.bindVendor();
        //this.bindService("");
        await this.bindProduct();
        await this.bindCountry();
        this.bindFields(this.chargeDetailData);
    }

    async bindFields(cell: any) {
        // console.log('cell', cell);
        if (cell) {
            this.Id = cell?.id;

            if (cell?.chargename){
                this.chargeDetailsForm.get('ddlCharge').setValue(cell.chargeid);
                this.chargeTypeFuelSurecharge = true;
                this.chargeDetailsForm.get('ddlCharge').setValidators([Validators.required]);
            } else {
                this.chargeTypeFuelSurecharge = false;
                this.chargeDetailsForm.get('ddlCharge').reset();
                this.chargeDetailsForm.get('ddlCharge').clearValidators();
            }
            this.chargeDetailsForm.get('ddlCharge').updateValueAndValidity();
            // console.log('destinationcountryList', this.destinationcountryList);

            const destinationcountry: any = cell.destinationcountrycode ?
                this.destinationcountryList.find((item: any) => item.code == cell.destinationcountrycode) : cell.destinationcountrycode;
            this.chargeDetailsForm.get('ddlDestinationCountry').setValue(destinationcountry?.isocode);
            await lastValueFrom(from(this.bindStatesByCountry(destinationcountry?.isocode)));

            const destinationstate: any = cell.destinationstatecode ?
                this.destinationStateList?.find((item: any) => item.code == cell.destinationstatecode) : cell.destinationstatecode;
            this.chargeDetailsForm.get('ddlDestinationState').setValue(destinationstate?.isocode);
            await lastValueFrom(from(this.bindCitiesByState(destinationstate?.isocode)));

            const destinationcity: any = cell.destinationcitycode ?
                this.destinationCityList.find(x => x.code == cell.destinationcitycode) : cell.destinationcitycode;
            this.chargeDetailsForm.get('ddlDestinationCity').setValue(destinationcity?.isocode);

            this.chargeDetailsForm.controls.ddlService.setValue(cell.servicename);

            this.chargeDetailsForm.get('ddlProduct').setValue(this.productOptions.find(x => x.code == cell.productcode)?.id);
            this.chargeDetailsForm.get('ddlVendor').setValue(this.vendorOptions.find(x => x.code == cell.vendorcode)?.id);
            this.bindService(
                this.vendorOptions.find(x => x.code === cell.vendorcode)?.id,
                (is_done) => {
                    if (is_done) {
                        this.chargeDetailsForm.get('ddlService').setValue(cell.servicename);
                    }
                }
            );
            this.chargeDetailsForm.get('txtCalculationBy').setValue(cell?.calculationby ? cell.calculationby.charAt(0).toUpperCase() + cell.calculationby.slice(1).toLowerCase() : '');
            this.chargeDetailsForm.get('txtMinimumAmount').setValue(cell.minimumamount);
            this.chargeDetailsForm.get('txtChargeableAmount').setValue(cell.chargeableamount);
        }
    }

    bindCharges() {
        this.chargesService.GetAll('').subscribe((res) => {
            this.chargesOptions = res?.success ? res.data : [];
        });
    }

    bindCustomer() {
        this.customerService.GetAll('').subscribe((res) => {
            this.customerOptions = res?.success ? res.data : [];
        })
    }

    async bindVendor() {
        const res = await lastValueFrom(this.vendorService.GetAll(''));
        if (res && res.success) {
            this.vendorOptions = res?.success ? res.data : [];
        }
    }

    // bindService(vendor_id: any, cb : any = null) {
    //     const vendorid = !vendor_id ? this.chargeDetailsForm.get('ddlVendor').value : vendor_id;
    //     this.chargeDetailsForm.get('ddlService').reset();
    //     this.vendorService.GetAllListByVendor({ id: vendorid }).subscribe((res) => {
    //         this.serviceOptions = res?.success ? res.data : [];
    //         cb(res?.success || false);
    //     });
    // }
    bindService(vendor_id: any, cb?: (success: boolean) => void): void {
        const vendorid = vendor_id || this.chargeDetailsForm.get('ddlVendor').value;

        this.chargeDetailsForm.get('ddlService').reset();

        this.vendorService.GetAllListByVendor({ id: vendorid }).subscribe((res) => {
            this.serviceOptions = res?.success ? res.data : [];

            if (cb) {
                cb(res?.success || false);
            }
        });
    }

    async bindProduct() {
        const res = await lastValueFrom(this.productService.GetAll(''));
        if (res && res.success) {
            this.productOptions = res?.success ? res.data : [];
        }
    }

    async bindCountry() {
        const observable = this.geoService.GetAllCountries();
        const res = await lastValueFrom(observable);
        if (res && res.success) {
            this.destinationcountryList = res.data;
        }
    }


    async bindStatesByCountry(countryCode?: string) {
        try {
            const observable = this.geoService.GetAllStates({ countrycode: countryCode });
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.countryCode = countryCode;
                this.destinationStateList = res.data;
            }
        } catch (e) {
            console.error(e);
        }
    }

    async bindCitiesByState(stateCode: string): Promise<void> {
        try {
            if (stateCode) {
                const observable = this.geoService.GetAllCities({ statecode: stateCode });
                const res = await lastValueFrom(observable);
                if (res && res.success) {
                    this.destinationCityList = res.data;
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    onDestinationCountryChange() {
        const selectedValue = this.chargeDetailsForm.get('ddlDestinationCountry').value;
        if (selectedValue) {
            this.bindStatesByCountry(selectedValue);
            this.chargeDetailsForm.get('ddlDestinationState').reset();
            this.chargeDetailsForm.get('ddlDestinationCity').reset();
            this.destinationCityList = [];
        }
    }

    onDestinationStateChange() {
        const selectedValue = this.chargeDetailsForm.get('ddlDestinationState').value;
        if (selectedValue) {
            this.bindCitiesByState(selectedValue);
            this.chargeDetailsForm.get('ddlDestinationCity').reset();
        }
    }

    // bindMappingDetails() {
    //     this.chargesService.MappingDetail_GetById(this.mappingId).subscribe((res) => {
    //         if (res && res.success) {
    //             this.mappingDetailsRowData = res.data || [];
    //             const data = this.mappingDetailsRowData ? this.mappingDetailsRowData[this.mappingDetailsRowData.length - 1] : {};
    //             this.detailForm.get('txtMin').setValue(data?.maxweight || '0');
    //             this.ngxLoaderService.stop();
    //         }
    //     })
    // }

    // selectChargeType() {
    //     this.isFormSubmitted = false;
    //     //this.chargeType = this.chargeDetailsForm.get('ddlChargeType').value;
    //     this.chargeType = 'Customer';
    //     let desc: string;
    //     if (this.chargeType == 'Vendor') {
    //         desc = 'Purchase';
    //         this.chargeDetailsForm.get('ddlCharge').reset();
    //         this.chargeDetailsForm.get('txtCustomer').setValue(null);
    //         this.chargeDetailsForm.get('txtCustomer').disable();
    //         this.chargeDetailsForm.get('txtCustomer').clearValidators();
    //         this.chargeDetailsForm.get('ddlVendor').setValidators([Validators.required]);
    //         this.chargeDetailsForm.get('txtCustomer').updateValueAndValidity();
    //         this.chargeDetailsForm.get('ddlVendor').updateValueAndValidity();
    //         this.mappingRowData = [];
    //     }
    //     else if (this.chargeType == 'Customer') {
    //         desc = 'AirWayBill';
    //         this.chargeDetailsForm.get('ddlCharge').reset();
    //         this.chargeDetailsForm.get('txtCustomer').enable();
    //         this.chargeDetailsForm.get('ddlVendor').clearValidators();
    //         this.chargeDetailsForm.get('txtCustomer').setValidators([Validators.required]);
    //         this.chargeDetailsForm.get('ddlVendor').updateValueAndValidity();
    //         this.chargeDetailsForm.get('txtCustomer').updateValueAndValidity();
    //         this.mappingRowData = [];
    //     }
    //     this.chargesService.GetByChargeType(desc).subscribe((res) => {
    //         this.chargesOptions = res?.success ? res.data : [];
    //     });
    //     this.onValueChange(this.chargeType);
    // }

    // onValueChange(type?: any) {
    //     //const chargetype = this.chargeDetailsForm.get('ddlChargeType').value;
    //     const chargetype = 'Customer';
    //     this.chargeType = type;
    //     let id: number;
    //     if (this.chargeType === 'Customer') {
    //         id = this.chargeDetailsForm.get('txtCustomer').value;
    //         this.ngxLoaderService.start();
    //         this.chargesService.Upload_GetAllList({ type, id }).subscribe((res) => {
    //             this.mappingRowData = res?.success ? res.data : [];
    //             this.mappingDetailsRowData = [];
    //             this.ngxLoaderService.stop();
    //         });
    //         this.ngxLoaderService.stop();
    //     }
    //     else if (this.chargeType == "Vendor") {
    //         id = this.chargeDetailsForm.get('ddlVendor').value;
    //         this.ngxLoaderService.start();
    //         this.chargesService.Upload_GetAllList({ type, id }).subscribe((res) => {
    //             this.mappingRowData = res?.success ? res.data : [];
    //             this.mappingDetailsRowData = [];
    //             this.ngxLoaderService.stop();
    //         });
    //         this.ngxLoaderService.stop();
    //     }
    // }

    getMapping(data: any) {
        this.ngxLoaderService.start();
        this.isMappingEdit = true;
        this.mappingId = data.id;
        this.chargeDetailsForm.patchValue({
            //ddlChargeType: data.chargetype,
            txtFromDate: this.formateDate(data.fromdate).dateString,
            txtToDate: this.formateDate(data.todate).dateString,
            txtCustomer: data.customerid,
            ddlVendor: data.vendorid,
            ddlProduct: data.productid,
            txtCalculationBy: data.calculationby,
            txtChargeableAmount: data.chargeableamount,
            txtMinimumAmount: data.minimumamount,
            ddlDestinationCountry: data.destinationcountrycode,
            ddlDestinationState: data.destinationstatecode,
            ddlDestinationCity: data.destinationcitycode
        });

        if (data.vendorid) {
            this.bindService("");
            this.chargeDetailsForm.get('ddlService').setValue(data.serviceid);
        }
        this.chargeDetailsForm.get('ddlCharge').setValue(data.chargeid);
    }

    upsertMapping() {
        //const origin = this.chargeDetailsForm.get('origin');
        //const destination = this.chargeDetailsForm.get('destination');
        // const fromdate = this.chargeDetailsForm.get('txtFromDate').value;
        // const todate = this.chargeDetailsForm.get('txtToDate').value;
        // if (fromdate > todate) {
        //     this.showErrorNotification("From Date can't be greater than To Date.");
        //     return;
        // }
        //// Check if the control is invalid
        // Object.keys(this.chargeDetailsForm.controls).forEach(key => {
        //     const control = this.chargeDetailsForm.controls[key];
        //     if (control.invalid) {
        //         console.log(`${key} control is invalid`);
        //     }
        // });

        this.isFormSubmitted = true;
        if (this.chargeDetailsForm.valid) {
            const reqObj = {
                id: this.Id,
                // chargetype: 'Customer',
                // fromdate: this.chargeDetailsForm.get('txtFromDate').value,
                // todate: this.chargeDetailsForm.get('txtToDate').value,
                chargeid: this.chargeDetailsForm.get('ddlCharge').value,
                chargename: this.chargesOptions.filter(x => x.id == this.chargeDetailsForm.get('ddlCharge').value)[0]?.name,
                //customerid: this.chargeDetailsForm.get('txtCustomer').value,
                vendorcode: this.vendorOptions.filter(x => x.id === this.chargeDetailsForm.get('ddlVendor').value)[0]?.code,
                servicename: this.chargeDetailsForm.get('ddlService').value,
                productcode: this.productOptions.filter(x => x.id === this.chargeDetailsForm.get('ddlProduct').value)[0]?.code,
                calculationby: this.chargeDetailsForm.get('txtCalculationBy').value,
                minimumamount: this.chargeDetailsForm.get('txtMinimumAmount').value,
                chargeableamount: this.chargeDetailsForm.get('txtChargeableAmount').value,
                origincountrycode: null,
                originstatecode: null,
                origincitycode: null,
                destinationcountrycode: this.destinationcountryList.filter(x => x.isocode === this.chargeDetailsForm.get('ddlDestinationCountry').value)[0]?.code,
                destinationstatecode: this.destinationStateList.filter(x => x.isocode === this.chargeDetailsForm.get('ddlDestinationState').value)[0]?.code,
                destinationcitycode: this.destinationCityList.filter(x => x.isocode === this.chargeDetailsForm.get('ddlDestinationCity').value)[0]?.code
            }
            //if (this.isMappingEdit) {
            this.ngxLoaderService.start();
            this.chargesService.Upload_Update(reqObj).subscribe((res) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Record Saved Successfully.', 'Success', 'success')
                    this.activeModal.close('Save Click');
                    this.resetForm();
                }
                else if (res && !res.success) {
                    this.ngxLoaderService.stop();
                    this.openWarningMessageDialog(res.message);
                }
                this.ngxLoaderService.stop();
            })

            // else {
            //     this.ngxLoaderService.start();
            //     this.chargesService.Upload_Add(reqObj).subscribe((res) => {
            //         if (res && res.success) {
            //             this.ngxLoaderService.stop();
            //             this.openMessageDialog('Record Added Successfully');
            //             this.resetForm();
            //         }
            //         else if (res && !res.success) {
            //             this.ngxLoaderService.stop();
            //             this.openWarningMessageDialog(res.message);
            //         }
            //     });
            //     this.ngxLoaderService.stop();
            // }
        }
    }

    // deleteMappingRecord(id) {
    //     try {
    //         if (id) {
    //             this.ngxLoaderService.start();
    //             this.chargesService.Upload_Delete(id).subscribe((res) => {
    //                 if (res && res.success) {
    //                     this.ngxLoaderService.stop();
    //                     this.resetForm();
    //                 }
    //             });
    //             this.ngxLoaderService.stop();
    //         }
    //     } catch (e) {
    //         console.error(e);
    //     }
    // }

    resetForm() {
        this.ngxLoaderService.start();
        // const chargetype = 'Customer';
        // const customer = this.chargeDetailsForm.get('txtCustomer').value;
        // const vendor = this.chargeDetailsForm.get('ddlVendor').value;
        this.chargeDetailsForm.reset();
        this.isFormSubmitted = false;
        this.isMappingEdit = false;
        this.mappingId = null;
        // if (chargetype == 'Customer') {
        //     this.chargeDetailsForm.patchValue({
        //         //ddlChargeType: chargetype,
        //         txtCustomer: customer,
        //         txtFromDate: this.currentDate,
        //         txtToDate: this.currentDate,
        //         txtCalculationBy: 'Percentage'
        //     });
        // }
        // else {
        //     this.chargeDetailsForm.patchValue({
        //         //ddlChargeType: chargetype,
        //         ddlVendor: vendor,
        //         txtFromDate: this.currentDate,
        //         txtToDate: this.currentDate,
        //         txtCalculationBy: 'Percentage'
        //     });
        // }

        // this.detailForm.reset();
        // this.isDetailFormSubmitted = false;
        // if (this.detailForm?.valid)
        //     this.detailForm.patchValue({
        //         ddlCalculationType: 'FLAT',
        //         txtMin: '0'
        //     });
        this.mappingDetailsRowData = [];

        //this.onValueChange(chargetype);
        this.ngxLoaderService.stop();
    }

    showSuccessNotification(msg: string) {
        this.toastr.success(msg, 'Success');
    }

    showWarningNotification(msg: any) {
        this.toastr.warning(msg, 'Warning');
    }

    showErrorNotification(msg: any) {
        this.toastr.error(msg, 'Error');
    }

    async openMessageDialog(msg: any, cb: any) {
        const result = await Swal.fire({
            title: 'Success!',
            text: msg,
            icon: 'success',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });

        cb(result);
    }

    openWarningMessageDialog(msg: any) {
        Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
    }


    formateDate(date?: any) {
        const inputDate = date != null || undefined ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const ss = inputDate.getSeconds() < 10 ? ('0' + inputDate.getSeconds()) : inputDate.getSeconds();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        return { dateString, dateTimeString };
    }

}
